// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2qWGT","list":"BalanceDue_list__3pAKm","listRow":"BalanceDue_listRow__27lPy","total":"BalanceDue_total__3w_-3"};